import { Link, useLocation } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/base/Seo";

export default function NotFound() {
  const location = useLocation();

  return (
    <SiteLayout>
      <Seo
        title="页面不存在｜黑瓜爆料"
        description="你访问的页面不存在或链接已失效，请返回首页或浏览全部追踪记录。"
        keywords="黑瓜爆料,页面不存在,404"
        path="/"
      />
      <section className="bg-background-50">
        <div className="mx-auto flex max-w-2xl flex-col items-center px-4 py-24 text-center md:py-32">
          <p className="mb-4 font-heading text-5xl font-bold text-background-300 md:text-7xl">
            404
          </p>
          <h1 className="mb-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            这条线索没有找到对应记录
          </h1>
          <p className="mb-2 text-sm leading-relaxed text-foreground-600 md:text-base">
            页面可能已被合并进另一条时间线，或者链接本身有误。
          </p>
          <p className="mb-6 font-label text-xs text-foreground-400">{location.pathname}</p>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-300 px-6 py-3 font-label text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-list-check-2" />
              浏览全部追踪
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}